import React, { Component } from 'react';
import { observer } from 'mobx-react';
import DocumentReloadStore from "Stores/DocumentReload/documentReloadStore";
import FiltersStore from 'Stores/DocumentReload/FiltersStore';
import AppStore from 'Stores/AppStore';
import DocumentLine from "Components/DocumentReload/documentLine";
import FiltersPanel from "Components/DocumentReload/filtersPanel";
import { Navigate } from 'react-router-dom';
import LoadView from "Components/Common/loadView";
import SmrTable from "Components/Common/SmrTable";
import Sorting from "Utils/Sorting";
import { ShowModal, CloseModal } from 'Utils/CommonFunctions';
import FiltersSimplePanel from "Components/Common/FiltersPanel/FiltersSimplePanel";

class DocumentReload extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Перезагрузка', 'documentReload', this.ReloadData);

        this.ReloadData();
    }

    componentWillUnmount() {
        DocumentReloadStore.ClearStore();
        FiltersStore.ClearStore();
    }

    ReloadData() {
        DocumentReloadStore.ClearStore();
        FiltersStore.GetInitData();
        DocumentReloadStore.GetData();
        CloseModal();
    }

    renderTableLine(item) {
        return (
            <DocumentLine
                item={item}
                OnReloadClicked={this.ReloadDocument.bind(this)}
                key={`history-line-${item.lid}`} />
        );
    }

    ReloadDocument(item) {
        DocumentReloadStore.ReloadDocument(item);
    }

    cleanTableData() {
        DocumentReloadStore.tableStore.CleanStore();
    }

    renderHeader() {
        return (
            <div className='document-history-table-header'>
                <div className="table-column-content-sortable" onClick={() => this.SetSortOrderNext("RegNum")}>
                    Рег. № {this.GetSortOrderIcon("RegNum")}
                </div>
                <div className="table-column-content-sortable" onClick={() => this.SetSortOrderNext("RegDate")}>
                    Дата регистрации {this.GetSortOrderIcon("RegDate")}
                </div>
                <div>
                    Перезагрузка
                </div>
            </div>
        );
    }

    GetSortOrderIcon(fieldName) {
        return Sorting.GetSortOrderIconParamValuesSort(FiltersStore.filters.sortRules, fieldName);
    }

    SetSortOrderNext(fieldName) {
        FiltersStore.filters.sortRules = Sorting.SetSortOrderNext(FiltersStore.filters.sortRules, fieldName);
        DocumentReloadStore.GetData();
    }

    render() {
        if (this.props.migrationInProcess) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        return (
            <div className='document-history-container'>
                <FiltersSimplePanel
                    className={(FiltersStore.initDataLoading ? ' disabled' : '')}
                    getFiltersRender={() => FiltersStore.filtersRender}
                    getFilters={() => FiltersStore.filters}
                    clearFilters={() => {
                        FiltersStore.ClearFiltersRender();
                        FiltersStore.SaveFiltersFromRender();
                        DocumentReloadStore.GetData(1);
                    }}
                    visibleFiltersFieldNames={["regNumAlias", "matchWholeWord"]}
                    search={() => DocumentReloadStore.GetData(1)}
                    getSelectedFiltersCount={() => FiltersStore.GetSelectedFiltersCount()}
                    showFullFilters={() => {
                        ShowModal({
                            className: "filters-modal",
                            canBeClosed: true,
                            blockProductSwitcher: true,
                            header: 'Фильтрация данных',
                            children: (<FiltersPanel />),
                            buttons:
                                [
                                    {
                                        content: 'Очистить',
                                        closer: false,
                                        onClick: _ => FiltersStore.ClearFiltersRender()
                                    }, {
                                        content: 'Применить',
                                        closer: true,
                                        className: "blue-button",
                                        onClick: _ => {
                                            FiltersStore.SaveFiltersFromRender();
                                            DocumentReloadStore.GetData(1);
                                        }
                                    }
                                ],
                            width: '480px',
                            height: "90%"
                        });
                    }}
                />
                <SmrTable
                    loading={DocumentReloadStore.recordsLoading}
                    renderTableLine={this.renderTableLine.bind(this)}
                    cleanTableData={this.cleanTableData.bind(this)}
                    renderHeader={this.renderHeader.bind(this)}
                    getDataPage={DocumentReloadStore.GetData.bind(DocumentReloadStore)}
                    location={this.props.location}
                    setTableStore={DocumentReloadStore.SetTableStore.bind(DocumentReloadStore)} />
                {DocumentReloadStore.reloadState.inProcess == false ? '' :
                    <LoadView modal={true}
                        loading={true}
                        loadText={`Производится перезагрузка ${AppStore.isMeeting ? "совещания" : "документа"} Рег № ${DocumentReloadStore.reloadState.regNum} от ${DocumentReloadStore.reloadState.regDate}`} />}
            </div>
        )
    }
}

export default observer(DocumentReload);